import React from "react";
import { NavLink } from "react-router-dom";

const SidebarItem = ({ path, iconClass, label, className }) => {
  return (
    <li className="yx-item">
      <NavLink
        to={path}
        className={({ isActive }) => `yx-link ${isActive ? "is-active" : ""} ${className || ""}`}
        end
        title={label} // nice for collapsed mode
      >
        <span className="yx-ic">
          {/* ✅ remove metismenu-icon completely */}
          <i className={iconClass} />
        </span>

        <span className="yx-tx">{label}</span>
      </NavLink>
    </li>
  );
};

export default SidebarItem;
